import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

class TaskCitationsService {
  getTaskCitations({ opportunityId, taskId }) {
    return ApiService.get(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/tasks/${taskId}/citations`,
    ).then((response) => response.data);
  }

  createTaskCitation({ opportunityId, taskId, citation }) {
    return ApiService.post(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/tasks/${taskId}/citations`,
      citation,
    ).then((response) => response.data);
  }

  deleteTaskCitation({ opportunityId, taskId, citationId }) {
    return ApiService.delete(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/tasks/${taskId}/citations/${citationId}`,
    ).then((response) => response.data);
  }
}

export const taskCitationsService = new TaskCitationsService();
